<ng-template (backdropClick)="onCloseClick()" cdkConnectedOverlay>
  <div data-testid="app-dropdown" (click)="onCloseClick()" class="dropdown-content">
    <ng-content></ng-content>
  </div>
</ng-template>
